var collapsible_list_component_rtlignore_default = {
  "ltr": "ohZDO",
  "rtl": "oan9D",
  "iconContainer": "xSRXP",
  "icon": "Fi9Hd",
  "isExpanded": "hOYzz",
  "listDimensions": "gIDyz"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore.scss.js.map
